// Generated by scripts/generate-region-progression-registry.mjs. Do not edit.
import region0 from "./black-forge-range.json" with { type: "json" };
import region1 from "./frontier-canyon.json" with { type: "json" };
import region2 from "./outer-forest.json" with { type: "json" };

export const RAW_REGION_BOSS_PROGRESSION = {
  black_forge_range: region0,
  frontier_canyon: region1,
  outer_forest: region2,
} as const;
